import { render } from "./InfoIcon.vue?vue&type=template&id=2670d13b"
const script = {}
script.render = render

export default script